import { Component, AfterContentInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

import { GeneralService } from '../../../@core/data/general.service';
import { PasswordValidation } from './password.validation';
import { AppUser } from '../../../@core/models/app.user';
import { LoginService } from '../../../@core/data/login.service';
import { LayoutService } from '../../../@core/data/layout.service';
import { generalSettings } from '../../../../main/settings';
import { FirebaseHelper } from '../../../@core/services/firebase.helper';

@Component({
  selector: 'edm-header-form',
  templateUrl: './form.header.component.html',
  styleUrls: ['./form.header.component.scss'],
  standalone: false,
})

export class HeaderFormComponent implements AfterContentInit {

  authForm: FormGroup;
  authenticating: boolean = false;

  pathBaseTranslate: string = 'theme.components.header.form.';

  constructor(
    private fb: FormBuilder,
    private activeModal: NgbActiveModal,
    private generalService: GeneralService,
    private loginService: LoginService,
    private layoutService: LayoutService,
    private firebaseHelper: FirebaseHelper
  ) {
    this.createForm();
  }

  ngAfterContentInit(): void {
    this.createForm();
    this.firebaseHelper.logEvent("screen_view", { screen_name: "password_change" });
  }

  private createForm(): void {
    this.authForm = this.fb.group({
      password: ['', Validators.required],
      confirmPassword: ['', Validators.required],
    }, {
      validator: PasswordValidation.MatchPassword,
    });
  }

  get password(): AbstractControl {
    return this.authForm.get('password');
  }

  get confirmPassword(): AbstractControl {
    return this.authForm.get('confirmPassword');
  }

  isFieldValid(field: string): boolean {
    return !this.authForm.get(field).valid && this.authForm.get(field).touched;
  }

  onSubmit(): void {
    if (this.authForm.valid && !this.authenticating) {
      this.authenticating = true;
      const formValues: AppUser = this.authForm.value;
      const entryModel: Partial<AppUser> = {
        password: formValues.password
      };
      this.generalService.updateProfile(entryModel)
      .subscribe(
        (done: AppUser): void => {
          this.loginService.storeToken(done.api_token);
          this.loginService.refreshLoggedUser();

          this.closeModal(true);
        },
        (): void => {
          this.closeModal('error');
        }
      );
    }
  }

  private validateAllFormFields(formGroup: FormGroup): void {
    Object.keys(formGroup.controls).forEach(
      (field: string): void => {
        const control: AbstractControl = formGroup.get(field);
        if (control instanceof FormControl) {
          control.markAsTouched({ onlySelf: true });
        } else if (control instanceof FormGroup) {
          this.validateAllFormFields(control);
        }
      }
    );
  }

  getTranslate(key: string): string {
    return this.generalService.getTranslate(`${this.pathBaseTranslate}${key}`);
  }

  closeModal(data: any = undefined): void {
    data !== undefined && data !== null ? this.activeModal.close(data) : this.activeModal.dismiss();
  }

  buttonCustomLayoutCss(): string {
    return this.layoutService.buttonCustomLayoutCss();
  }

  iconCustomLayoutClass(): string {
    return generalSettings.timelineIconsLayout + '-icon';
  }

  iconTypeLayoutClass(): string {
    return generalSettings.iconsType + '-icons-type';
  }
}
